export default "__VITE_PUBLIC_ASSET__55391a55__"